import React, { FunctionComponent } from "react";
import { Badge, Skeleton, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";


interface IProps {
  state?: number;
}

export const CONTROL_MODE = {
  NONE: 0,
  OFF: 1,
  REACTIVE_POWER: 2,
  POWER_FACTOR: 3,
  VOLTAGE: 4,
}


const ControlMode: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case CONTROL_MODE.NONE:
      return (
        <Badge variant={"outline"} colorScheme={"gray"} title={intl.formatMessage({
            id: "command__control_mode__status__none",
            defaultMessage: "No state",
          })}>
          <Box display="inline-block" w="2" h="3" />
        </Badge>
      )
    case CONTROL_MODE.OFF:
      return (
        <Badge variant="solid" colorScheme={"blue"}>
          {intl.formatMessage({
            id: "command__control_mode__status__off",
            defaultMessage: "OFF",
          })}
        </Badge>
      )
    case CONTROL_MODE.REACTIVE_POWER:
      return (
        <Badge variant="solid" colorScheme={"orange"}>
          {intl.formatMessage({
            id: "command__control_mode__status__reactive_power",
            defaultMessage: "REACTIVE POWER",
          })}
        </Badge>
      )
    case CONTROL_MODE.POWER_FACTOR:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "command__control_mode__status__power_factor",
            defaultMessage: "POWER FACTOR",
          })}
        </Badge>
      )
    case CONTROL_MODE.VOLTAGE:
      return (
        <Badge variant="solid" colorScheme={"yellow"}>
          {intl.formatMessage({
            id: "command__control_mode__status__voltage",
            defaultMessage: "VOLTAGE",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default ControlMode;
